module.exports = __webpack_public_path__ + "assets/img/code1.17a5f840.png";